import Vue from 'vue'

import VueCookies from 'vue-cookies'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/main.scss'

import App from './App.vue'
import router from './routes'
import store from './store'
import VueGtm from '@gtm-support/vue2-gtm'

Vue.use(VueCookies)
Vue.use(BootstrapVue)
Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    nonce: '2726c7f26c',
    enabled: Vue.$cookies.get("AnalyticsCookieAcceptanceStatus") === 'accepted',
    debug: process.env.VUE_APP_GA_DEBUG === "true",
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')